// utils/geocodeAddress.js
import axios from "axios";

const getCoordinatesFromAddress = async (address) => {
   const apiKey = "AIzaSyD0AcxoBWhqkMIAfK-F-X6ya3Es-52o1YU";
  try {
    const response = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`
    );
    const location = response.data.results[0]?.geometry.location;
    return location
      ? { latitude: location.lat, longitude: location.lng }
      : null;
  } catch (error) {
    console.error("Geocoding failed for:", address, error);
    return null;
  }
};

export default getCoordinatesFromAddress;
